"use client";

import { motion } from "framer-motion";

import { useReveal } from "./reveal";

// Shared shell for every tile in the stats bento: the panel surface plus the
// rise-in reveal. `index` staggers the cards so they arrive in reading order.
//
// The surface tone varies per card (the design gives the AWS and CDN tiles their
// own slightly different greys), so the background comes in through className
// rather than being fixed here.
export default function BentoCard({ index = 0, className = "", children }) {
  const { reveal } = useReveal();

  return (
    <motion.article
      {...reveal}
      custom={index}
      className={`relative overflow-hidden rounded-[20px] outline outline-1 -outline-offset-1 outline-white/5 ${className}`}
    >
      {children}
    </motion.article>
  );
}
